/**
 * Z-Index constants for Map panels
 * Centralized management of z-index values to avoid conflicts
 */

export const PanelZIndex = {
  // Base level panels
  BASE: 10,

  // Standard panels (dropdowns, sidebars)
  STANDARD: 1000,

  // Higher priority panels (modals, overlays)
  HIGH: 9999,

  // Top priority (dialogs, full-screen overlays)
  TOP: 999999,
} as const;

// Alias for backward compatibility
export const Z_INDEX = PanelZIndex;
